import { inject, Injectable } from '@angular/core';
import { Observable, tap, throwError } from 'rxjs';
import { BaseApiService } from '@data-access/common/base-api.service';
import { Router } from '@angular/router';
import { LoginResponse } from '@shared/interfacres/user';

@Injectable({providedIn: 'root'})
export class AuthService extends BaseApiService {

  router = inject(Router);

  private accessTokenKey = 'access_token';
  private refreshTokenKey = 'refresh_token';

  getAccessToken(): string | null {
    return localStorage.getItem(this.accessTokenKey);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(this.refreshTokenKey);
  }

  setTokens(accessToken: string, refreshToken: string): void {
    localStorage.setItem(this.accessTokenKey, accessToken);
    localStorage.setItem(this.refreshTokenKey, refreshToken);
  }

  refreshToken(): Observable<LoginResponse> {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) {
      return throwError(() => new Error('No refresh token available.'));
    }

    return this._httpClient.post<LoginResponse>(`${this.apiUrl}/auth/refresh`, { refresh_token: refreshToken }).pipe(
      tap((response: LoginResponse) => {
        this.setTokens(response.session.access_token, response.session.refresh_token);
      })
    );
  }

  logout() {

    localStorage.removeItem(this.accessTokenKey);
    localStorage.removeItem(this.refreshTokenKey);
    this.router.navigate(['/login']);
  }
}
